/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2022 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */
import React, {useState, useEffect, useRef} from 'react';
import DismantlerLayout from "../../layouts/DismantlerLayout";
import FiltersParts from "../../components/FiltersParts";
import SearchByModel from "../../components/SearchByModel";
import ListingTop from "../../components/ListingTop";
import {Link, useOutletContext, useParams} from "react-router-dom";
import PartImage from "../../assets/img/partImage.jpg";
import {ReactComponent as Map} from "../../assets/img/icons/map.svg";
import ListingBottom from "../../components/ListingBottom";
import axios from "axios";
import Loader from "../../elements/loader";
import PartBox from "../../components/PartBox";
import {ReactComponent as PaginationStart} from "../../assets/img/icons/pagination-start.svg";
import {ReactComponent as PaginationLeft} from "../../assets/img/icons/pagination-left.svg";
import {ReactComponent as PaginationRight} from "../../assets/img/icons/pagination-right.svg";
import {ReactComponent as PaginationEnd} from "../../assets/img/icons/pagination-end.svg";
import {getDismantler} from "../../Hooks/DesmantlerData";
import {useTranslation} from "react-i18next";
import useAxiosJTW from "../../Hooks/useAxiosJTW";

const DismantlerPartsCategory = () => {

    let params = useParams();
    const { t, i18n } = useTranslation();
    const axiosJWT = useAxiosJTW();

    const isInitialSort = useRef(true);
    const isInitialParams = useRef(true);

    const queryParameters = new URLSearchParams(window.location.search);
    const _spec = queryParameters.get("spec");

    const [dataToSend, setDataToSend] = useState({
        page : 1,
        sort: 'date-desc',
        merchantid: params.merchantid,
        part_title: params.part,
        limit: 50,
        spec: _spec
    });

    const scrollTop = useRef(null);

    const [sortValue, setSortValue] = useState('date-desc');

    const [parts, setParts] = useState([]);
    const [partCategories, setPartCategories] = useState([]);
    const [outletData, setOutletData] = useOutletContext();

    const [totalPages, setTotalPages] = useState(1);
    const [totalItems, setTotalItems] = useState(0);

    const [isLoading, setIsLoading] = useState(true);

    const getpartsbymerchantid = () => {

        axiosJWT.post('api/getpartsbymerchantid', dataToSend).then( (response) => {
            if(response.status === 200){
                setParts(response.data.parts || []);

                if( response.data.part_categories ){
                    setPartCategories(response.data.part_categories);
                }

                const dismantler = getDismantler(response.data.merchant_info, response.data.schedule);
                setOutletData(dismantler);

                setTotalPages( parseInt(response.data.total_pages) || 1 );
                setTotalItems(  parseInt(response.data.total_parts) );

                setIsLoading(false);

            }
        } ).catch((error) => {
            console.log(error);
        });
    }

    useEffect(() => {
        setIsLoading(true);
        getpartsbymerchantid( dataToSend);

    }, [dataToSend]);

    useEffect(() => {
        if (isInitialParams.current) {
            isInitialParams.current = false;
        } else {

            const queryParameters = new URLSearchParams(window.location.search);
            const _spec = queryParameters.get("spec");

            setDataToSend(prevState => ({
                ...prevState,
                page: 1,
                part_title: params.part,
                spec: _spec
            }));
        }
    }, [params]);

    useEffect(() => {
        if (isInitialSort.current) {
            isInitialSort.current = false;
        } else {
            setDataToSend(prevState => ({
                ...prevState,
                page: 1,
                sort: sortValue
            }));
        }
    }, [sortValue]);

    return (
        // <DismantlerLayout>
        <div ref={scrollTop} className='page-row'>
            <div className='page-sidebar'>
                <FiltersParts dismantlerPartsCategories={partCategories}/>
            </div>
            <div className='page-content'>

                <ListingTop onSort={setSortValue} value={sortValue}  count={totalItems}/>

                <div className='partBoxs'>

                    {isLoading ? (
                        <div style={{ paddingTop: '30px', textAlign : 'center' }}><Loader/></div>
                    ) : (
                        parts.map((item, index) => {
                            return (
                                <PartBox key={index} part={item} link={`/${i18n.language}/used-part/${encodeURIComponent(item.slug)}/${item.make_slug}/${item.model_slug}/${item.year}/${item.city_slug}/${item.code}`}/>
                            );
                        })
                    )}

                </div>

                <ListingBottom currentPage={dataToSend.page} totalPages={totalPages} onChangePage={setDataToSend} scrollTop={scrollTop}/>

            </div>
        </div>
        // </DismantlerLayout>
    );
};

export default DismantlerPartsCategory;
